define(function(require, exports, module) {
    'use strict';

    var core = require('core');
    const { dispatcher } = require('bundle');

    dispatcher.listen('user:details:hideBalance', function(data) {
        core.trigger('user:details:hideBalance', data);
    });

    core.listenTo(core, 'user:model:update', () => {
        dispatcher.dispatch('user:model:update');
    });

    module.exports = core;
});
